<!-- eslint-disable -->
<template lang="pug">
        .battle-create__block
                .battle-create-form
                        .battle-create-form__header
                                div(slot="title")
                                        | {{ $i18n.t('olympiads.olympiads_editLevel_group') }}
                                        =" "
                                        span(v-text="+index + 1")
                        divider
                        stage-form(
                            v-for="(stage, i) in stages",
                            :stage-index="i",
                            :stage="stage",
                            :key="i",
                            :games="games",
                            @removeStage="removeStage",
                            @upStage="upStage",
                            @downStage="downStage"
                            :is-trainer="isTrainer"
                        )
                        divider
                        .battle-stage__block--center
                                cs-button(
                                    pattern="primary-outline",
                                    color="blue",
                                    @click="addStage"
                                )
                                        svg-icon(name="plus", middle)
                                        |
                                        | {{ $i18n.t('olympiads.olympiads_editLevel_addStage') }}
                        divider
                        .battle-stage__button-group
                                cs-button.battle-stage__button(
                                    pattern="primary-outline",
                                    color="blue",
                                    @click="$router.back()"
                                )
                                        | {{ $i18n.t('common.common_button_cancel') }}
                                =" "
                                cs-button.battle-stage__button(color="blue", @click="save")
                                    | {{ $i18n.t('olympiads.olympiads_editLevel_save') }}
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../utils/trainer/trainer';
    import BoxHeader from '../../elements/BoxHeader.vue';
    import StageForm from './StageForm.vue';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import stageTemplate from './config/stageTemplate.json';

    export default {
        mixins: [TrainerUtilities],
        props: {
            index: {
                type: [Number, String],
                default: 0,
            },
            battleId: {
                type: [Number, String],
                default: 0,
            },
            isTrainer: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            if (this.stage || this.battle) {
                this.level = this.battle.levels[+this.index];
                this.courseGames = this.level.course.games;
                this.courseGames = this.courseGames.filter(game => {
                    return game.slug !== 'Shutter';
                });
                this.courseGames.forEach(game => {
                    if (game.slug === 'CatchWord') {
                        game.parameters.default.mode = 'interactive';
                    }
                    game.name = this.getGameName(game);
                    return game;
                });
                this.intermediateState = this.stage || _.cloneDeep(this.battle);
                this.stages = _.cloneDeep(this.intermediateState.levels[+this.index]['stages']);
                this.$store.dispatch('setIntermediateBattleStage', this.intermediateState);
            } else {
                this.$router.push({ name: this.isTrainer ? 'battle-training:form' : 'battle:form' });
            }
        },
        beforeRouteLeave(to, from, next) {
            const allowedPathsWithoutStage = this.isTrainer
                ? ['battle-training:form', 'battle-training:edit']
                : ['battle:form', 'battle:edit'];
            const allowedPaths = this.isTrainer
                ? ['battle-training-stage-game:edit', ...allowedPathsWithoutStage]
                : ['battle-stage-game:edit', ...allowedPathsWithoutStage];
            if (allowedPathsWithoutStage.includes(to.name)) {
                this.$store.dispatch('setIntermediateBattleStage', null);
            }
            if (!allowedPaths.includes(to.name)) {
                this.$store.dispatch('setBattle', null);
                this.$store.dispatch('setIntermediateBattleStage', null);
            }
            if (this.battleId) {
                to.params.battleId = this.battleId;
            }
            next();
        },
        watch: {
            stages: {
                handler(value) {
                    if (value) {
                        this.intermediateState.levels[+this.index]['stages'] = value;
                        this.$store.dispatch('setIntermediateBattleStage', this.intermediateState);
                    }
                },
                immediate: true,
                deep: true,
            },
        },
        data() {
            return {
                stages: null,
                intermediateState: null,
                courseGames: null,
                level: null,
            };
        },
        computed: {
            ...mapState({
                battle: state => state.battle.battle,
                stage: state => state.battle.intermediateBattleStage,
            }),
            games() {
                let games = _.cloneDeep(this.courseGames);
                games.forEach(game => (game.name = this.getGameName(game)));
                return games;
            },
            puzzlesAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Puzzle') {
                            return !(game.parameters.default.games.length && game.parameters.default.image);
                        }
                        return false;
                    });
                });
            },
            anagramsAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Anagrams') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            wordsFieldIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'WordsField') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            textsAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Texts') {
                            return !game.parameters.default.sourceText;
                        }
                        return false;
                    });
                });
            },
            lettersFieldIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'LettersField') {
                            return !(
                                game.parameters.default.selectedLetters &&
                                game.parameters.default.selectedLetters.length
                            );
                        }
                        return false;
                    });
                });
            },
            catchWordIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'CatchWord') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            punctuationMarksAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'PunctuationMarks') {
                            return !game.parameters.default.sourceText;
                        }
                        return false;
                    });
                });
            },
        },
        methods: {
            getValidateRule(index) {
                return index === 0
                    ? ''
                    : this.stages[index - 1].endTime
                    ? '|after:' + this.stages[index - 1].endTime
                    : '';
            },
            save() {
                if (!(this.games && !_.isEmpty(this.games))) {
                    this.$toasted.error(this.$i18n.t('homework.homework_create_noGamesError'));
                    return;
                }
                if (this.puzzlesAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_puzzle'),
                        })
                    );
                    return;
                }
                if (this.wordsFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_wordsField'),
                        })
                    );
                    return;
                }
                if (this.anagramsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_anagrams'),
                        })
                    );
                    return;
                }
                if (this.textsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_texts'),
                        })
                    );
                    return;
                }
                if (this.lettersFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_lettersField'),
                        })
                    );
                    return;
                }
                if (this.catchWordIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_catchWord'),
                        })
                    );
                    return;
                }
                if (this.punctuationMarksAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_punctuationMarks'),
                        })
                    );
                    return;
                }
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.intermediateState.levels[+this.index]['stages'].forEach((elem, index) => {
                            elem.position = index;
                        });
                        this.$store.dispatch('setBattle', this.intermediateState);
                        this.$router.back();
                    }
                });
            },
            addStage() {
                this.stages.push(_.cloneDeep(stageTemplate));
            },
            upStage(index) {
                if (index === 0) {
                    return;
                } else {
                    let origin = this.stages[index];
                    this.stages[index] = this.stages[index - 1];
                    this.$set(this.stages, index - 1, origin);
                }
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
            downStage(index) {
                if (index === this.stages.length - 1) {
                    return;
                } else {
                    let origin = this.stages[index];
                    this.stages[index] = this.stages[index + 1];
                    this.$set(this.stages, index + 1, origin);
                }
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
            removeStage(index) {
                this.stages.length > 1 && this.stages.splice(index, 1);
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
        },
        components: {
            BoxHeader,
            StageForm,
        },
    };
</script>

<style lang="scss" scoped>
    .battle-create__block {
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
            padding: 28px 30px;
        }
    }

    .battle-create-form {
        margin: 0;
        padding: 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: 20px;
        @include media($md) {
            padding: 30px;
        }
        @include media($lg) {
            padding: 30px 15% 30px 15%;
        }
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .battle-create-form__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .battle-stage__block--center {
        text-align: center;
        .svg-icon {
            margin-right: 5px;
        }
    }

    .battle-stage__button-group {
        display: flex;
    }

    .battle-stage__button {
        &:first-child {
            margin-right: 10px;
        }
        @include media($sm) {
            margin-right: 20px;
        }
    }
</style>
